import { Component } from 'react';
import { FormGroup, Input as BootstrapInput, Label } from 'reactstrap';

import './input-checkbox.css';

class InputCheckbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ischecked: false,
    };
  }

  componentDidMount() {
    if (this.props.ischecked !== this.state.ischecked) {
      this.setState({ ischecked: this.props.ischecked });
    }
  }

  toggleCheckboxChange = () => {
    const { handlecheckboxchange, label } = this.props;

    this.setState(({ ischecked }) => ({
      ischecked: !ischecked,
    }));

    handlecheckboxchange(label);
  };

  render() {
    const { label, ...rest } = this.props;
    const fieldId = this.props.id ? toString(this.props.id) : this.props.name;

    return (
      <FormGroup className="m-2">
        <BootstrapInput
          {...rest}
          type="checkbox"
          value={label}
          checked={this.state.ischecked}
          onChange={this.toggleCheckboxChange}
        />
        <Label className="font-weight-bold mb-0" for={fieldId}>
          {label}
        </Label>
      </FormGroup>
    );
  }
}

export default InputCheckbox;
